import { Store, User, Calendar, Clock } from "lucide-react";

interface CashSessionStatsProps {
  registerName: string;
  userName: string;
  openingTime: string;
}

const CashSessionStats: React.FC<CashSessionStatsProps> = ({
  registerName,
  userName,
  openingTime,
}) => {

  const date = new Date(openingTime);

  const formattedDate = date.toLocaleDateString();
  const formattedTime = date.toLocaleTimeString();

  const items = [
    { icon: Store, label: "Terminal", value: registerName },
    { icon: User, label: "Usuario", value: userName },
    { icon: Calendar, label: "Fecha", value: formattedDate },
    { icon: Clock, label: "Hora", value: formattedTime },
  ];

  return (

    <div className="grid grid-cols-1 gap-4 px-6 py-6 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4">

      {items.map((item, index) => {

        const Icon = item.icon;

        return (

          <div
            key={index}
            className="flex items-center gap-3 rounded-md p-2 transition hover:bg-gray-1 dark:hover:bg-meta-4"
          >

            {/* ICON */}
            <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-md bg-primary/10 text-primary">
              <Icon size={18}/>
            </div>

            {/* TEXT */}
            <div className="min-w-0">

              <p className="text-xs text-body dark:text-bodydark">
                {item.label}
              </p>

              <p className="truncate font-medium text-black dark:text-white">
                {item.value}
              </p>

            </div>

          </div>

        );

      })}

    </div>

  );

};

export default CashSessionStats;